<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="a-september-day-by-the-sea">
<h1>A September Day by the Sea</h1>
<p>I sit by the sea, to see the sea</p>
<p>I see waves coming into the shore</p>
<p>The whites of waves so beautiful</p>
<p>The yellow sand so clean, I adore</p><br/>
<p>A boat in the distance</p>
<p>A bird flying high</p>
<p>You see the sea</p>
<p>Right up to the Sky</p><br/>
<p>Walkers walking dogs</p>
<p>Both pooing and farting</p>
<p>Sun hits the water</p>
<p>As dogs start barking</p><br/>
<p>A lady in the sea</p>
<p>Not feeling the chill</p>
<p>She will surely catch cold</p>
<p>And be needing a pill</p><br/>
<p>The grey brown stones</p>
<p>On the beach in a cluster</p>
<p>Some dull some shine</p>
<p>As birds start to muster</p><br/>
<p>The sun pops in</p>
<p>Behind the clouds</p>
<p>As the chill hits the air</p>
<p>It disperses the crowds</p><br/>
<p>Sun diamonds in the sand</p>
<p>Looks so beautiful and real</p>
<p>As the beach starts to clean</p>
<p>As the night tide draws near</p><br/>
<p>Another day over</p>
<p>What a great and lovely day</p>
<p>Must do this again</p>
<p>Back soon on the beach to lay.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?52a14803